import { render, staticRenderFns } from "./ResponsiblesEdit.vue?vue&type=template&id=13f494ee&"
import script from "./ResponsiblesEdit.vue?vue&type=script&lang=js&"
export * from "./ResponsiblesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports